// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/internals/enum-bug-keys.js